import { useState } from 'preact/hooks';
import { DAYS, closureForDate, type DayIndex } from '../../lib/calendar.ts';
import { addDays, frWeekRange } from '../../lib/dates.ts';
import { useStore } from '../../store/store.ts';
import { closeModal, toast } from '../../ui/ui-store.ts';

export function CopyDayModal() {
  const monday = useStore((s) => s.currentMonday)();
  const [from, setFrom] = useState<DayIndex>(0);
  const [to, setTo] = useState<DayIndex>(1);

  function run() {
    if (from === to) {
      toast('Choisis deux jours différents');
      return;
    }

    const closure = closureForDate(addDays(monday, to));
    if (closure) {
      toast(`${DAYS[to]} est un jour de congé`);
      return;
    }

    if (!confirm(`Remplacer le contenu de ${DAYS[to]} par celui de ${DAYS[from]} ?`)) return;

    useStore.getState().copyDay(from, to);
    closeModal();
    toast('Journée copiée');
  }

  return (
    <>
      <p class="muted">{frWeekRange(monday)}</p>

      <div class="formGrid">
        <div>
          <label for="copyFrom">Copier</label>
          <select
            id="copyFrom"
            value={String(from)}
            onChange={(e) => setFrom(Number(e.currentTarget.value) as DayIndex)}
          >
            {DAYS.map((name, i) => (
              <option key={name} value={String(i)}>
                {name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label for="copyTo">Vers</label>
          <select
            id="copyTo"
            value={String(to)}
            onChange={(e) => setTo(Number(e.currentTarget.value) as DayIndex)}
          >
            {DAYS.map((name, i) => {
              const closure = closureForDate(addDays(monday, i));
              return (
                <option key={name} value={String(i)} disabled={closure !== null}>
                  {name}
                  {closure ? ` — ${closure.label}` : ''}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      <div style={{ marginTop: '14px' }}>
        <button class="btn primary" onClick={run}>
          Copier la journée
        </button>
      </div>
    </>
  );
}
